import Axios from 'axios';
import Resource from 'bol-rest/resource';
import displayApiError from '../modules/notifications/actions/displayApiError';
import displayInfo from '../modules/notifications/actions/displayInfo';

export const AXIOS_CONFIG = {
    baseURL: '/api/v1',
};

export const api = Axios.create(AXIOS_CONFIG);

api.interceptors.response.use(
    response => response,
    (error) => {
        if (error.constructor && error.constructor.name === 'Cancel') {
            return;
        }

        if (error.response && error.response.data && error.response.data.meta && error.response.data.meta.code === '1') {
            displayInfo(() => ({
                icon: 'warning',
                text:
                    'Met deze review is reeds iemand bezig.',
            }))({});
        } else {
            displayApiError({ props: { error } });
        }

        throw error;
    }
);

// no global error messages are shown with this axios instance
// usefull for non crutial background api call
const silentApi = Axios.create(AXIOS_CONFIG);

export const Author = Resource(api, '/author');
export const User = Resource(api, '/user');
export const ReviewRevision = Resource(api, '/review/revision');
export const Review = Resource(api, '/review/requests', null, true);

export const ResourceForms = Resource(api, '/resource/forms');
export const ResourceSearch = Resource(api, '/resource/search');
export const ResourceTree = Resource(api, '/resource/tree');
export const ResourceLaw = Resource(api, '/resource/laws');
export const ResourceAnnotation = Resource(api, '/resource/annotations');
export const ResourceAnnotationGroups = Resource(
    api,
    '/resource/annotation-groups'
);
export const ResourcePageGroups = Resource(api, '/resource/page-groups');

export const ResourceArticle = Resource(api, '/resource/articles');
export const ResourcePseudoArticle = Resource(api, '/resource/pseudo_articles');
export const ResourceBook = Resource(api, '/resource/books');
export const ResourcePart = Resource(api, '/resource/parts');
export const ResourcePage = Resource(api, '/resource/pages');
export const ResourceChapter = Resource(api, '/resource/chapters');
export const ResourceInscription = Resource(api, '/resource/inscriptions');
export const ResourceTitle = Resource(api, '/resource/titles');
export const ResourceAttachment = Resource(api, '/resource/attachments');
export const ResourceDepartment = Resource(api, '/resource/departments');
export const ResourceSubdepartment = Resource(api, '/resource/subdepartments');
export const ResourceSection = Resource(api, '/resource/sections');
export const ResourceSubsection = Resource(api, '/resource/subsections');
export const ReviewSources = Resource(api, '/review/sources');
export const InternalReference = Resource(api, '/internal-reference');

export const Publication = Resource(api, '/snapshot');
export const PublicationResource = Resource(api, '/snapshot-resource');
export const BackgroundProcess = Resource(api, '/background-process');
export const BackgroundProcessSilent = Resource(silentApi, '/background-process');
export const BackgroundChainProcess = Resource(api, '/background-chain');

const resources = {
    forms: ResourceForms,
    search: ResourceSearch,
    tree: ResourceTree,
    laws: ResourceLaw,
    annotations: ResourceAnnotation,
    'annotation-groups': ResourceAnnotationGroups,
    'page-groups': ResourcePageGroups,
    articles: ResourceArticle,
    pseudo_articles: ResourcePseudoArticle,
    books: ResourceBook,
    parts: ResourcePart,
    pages: ResourcePage,
    chapters: ResourceChapter,
    inscriptions: ResourceInscription,
    titles: ResourceTitle,
    attachments: ResourceAttachment,
    departments: ResourceDepartment,
    subdepartments: ResourceSubdepartment,
    sections: ResourceSection,
    subsections: ResourceSubsection,
    internalreference: InternalReference,
};

export default {
    authors: Author,
    resources,
    reviews: Review,
    reviewRevisions: ReviewRevision,
    reviewSources: ReviewSources,
    users: User,
    publications: Publication,
    publicationResources: PublicationResource,
    backgroundProcess: BackgroundProcess,
    backgroundChainProcess: BackgroundChainProcess,
};
